interface DomainRedeemCodeMapping {
    [domain: string]: string;
}
export const DOMAIN_REDEEM_CODES: DomainRedeemCodeMapping = {
    "channel4.co.uk": "CH4ZEN",
    "eskenzipr.com": "ESKENZIPR",
};  
